module.exports = __webpack_public_path__ + "img/card_icon_six.632a555a.png";